import React from 'react';
//@ts-ignore
import s from './ListParams.module.scss'

export type ListParamsT = {
    list: any[]
}

export const ListParams = ({ ...props }: ListParamsT) => {
    const { list } = props;
    return (
        <div className={s.listParams}>
            {list.map(item => {
                return (<li key={item} >{item}</li>)
            })}
        </div>
    )
}
